/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './sendMessage.defs'
export { main as default } from './sendMessage.defs'
